import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showWebview } from '../actions/webview';
import { ACTION_TYPES } from '../constants/message';
import { WIDGET_STATE } from '../constants/app';

export class WebviewActionComponent extends Component {
    static propTypes = {
        actionStyle: PropTypes.object,
        isScrolledToBottom: PropTypes.bool.isRequired,
        lastReceivedMessageId: PropTypes.string,
        messageId: PropTypes.string,
        openOnReceive: PropTypes.bool.isRequired,
        settingsVisible: PropTypes.bool.isRequired,
        showWebview: PropTypes.func.isRequired,
        size: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        uploadVisible: PropTypes.bool.isRequired,
        uri: PropTypes.string.isRequired,
        userIsTyping: PropTypes.bool.isRequired,
        webviewIsShown: PropTypes.bool.isRequired,
        widgetState: PropTypes.symbol.isRequired,
    };

    static defaultProps = {
        widgetState: WIDGET_STATE.CLOSED,
        settingsVisible: false,
        userIsTyping: false,
        uploadVisible: false,
        webviewIsShown: false,
        isScrolledToBottom: false,
        openOnReceive: false,
        lastReceivedMessageId: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            hasBeenOpened: false,
        };
        this.openWebview = this.openWebview.bind(this);
    }

    componentDidMount() {
        this.openOnReceive();
    }

    openWebview() {
        const { showWebview, uri, size } = this.props;

        showWebview({
            uri,
            size,
        });

        this.setState({
            hasBeenOpened: true,
        });
    }

    openOnReceive() {
        const {
            type,
            openOnReceive,
            widgetState,
            settingsVisible,
            lastReceivedMessageId,
            webviewIsShown,
            uploadVisible,
            isScrolledToBottom,
            userIsTyping,
            messageId,
        } = this.props;

        const { hasBeenOpened } = this.state;

        const shouldOpen =
            messageId === lastReceivedMessageId &&
            (widgetState === WIDGET_STATE.OPENED || widgetState === WIDGET_STATE.EMBEDDED) &&
            isScrolledToBottom &&
            !settingsVisible &&
            !webviewIsShown &&
            !userIsTyping &&
            !uploadVisible &&
            type === ACTION_TYPES.WEBVIEW &&
            openOnReceive &&
            !hasBeenOpened;

        if (shouldOpen) {
            this.openWebview();
        }
    }

    onWebviewClick = (e) => {
        e.preventDefault();
        this.openWebview();
    };

    render() {
        const { actionStyle, text } = this.props;

        return (
            <div className="btn btn-primary" style={actionStyle} onClick={this.onWebviewClick}>
                {text}
            </div>
        );
    }
}

const mapStateToProps = ({
    appState: { widgetState, settingsVisible, uploadVisible, userIsTyping, activeConversationId },
    conversations,
    webview,
    ui: { isAtBottom },
}) => {
    const { lastReceivedMessageId } = conversations[activeConversationId];
    return {
        widgetState,
        settingsVisible,
        uploadVisible,
        userIsTyping,
        isScrolledToBottom: isAtBottom,
        webviewIsShown: webview.isShown,
        lastReceivedMessageId,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            showWebview,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(WebviewActionComponent);
